export { default } from '@/components/Pages/GiftPage.web';
